import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { LOGIN_URL, LOGOUT_URL, MYPAGE_URL } from "../config";

import LOGO_MAIN from "../assets/images/logo_geobig_main_small.png";
import LOGO_SUB from "../assets/images/logo_geobig_sub_small.png";

export function NavigationBar() {
  const isLoggedIn = useSelector((state) => state.user.login);
  const userName = useSelector((state) => state.user.name);

  const location = useLocation();
  const currentPath = location.pathname;
  const currentUrl = window.location.href;

  const { t, i18n } = useTranslation();

  const isHome = currentPath === "/";
  const logoImagePath = isHome ? LOGO_MAIN : LOGO_SUB;
  const logoColor = isHome ? "#fff" : "#252525";
  const menuIconClass = isHome ? "icon" : "icon icon-bar-sub";

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div id="header">
      <div className="bar">
        <nav className={isHome ? "nav-layout" : "nav-layout-sub"}>
          <div className="nav-wrapper container top_nav_wrap">
            <div className="brand-logo">
              <a id="logo-container" href="https://data.kigam.re.kr/">
                <img src={logoImagePath} alt="logo - 지오빅데이터 오픈플랫폼" />
              </a>
              <span style={{ fontSize: "1.6rem", color: logoColor }}>
                &nbsp; |{" "}
                <Link to="/">
                  <span style={{ color: logoColor }}>
                    <strong>{t("menu.title")}</strong>
                  </span>
                </Link>
              </span>
            </div>
            <ul id="mmenuContainer" className="right hide-on-med-and-down">
              <li className="menu">
                <Link to="/intro" className="nav_menu_a v_menu1 v_menu1_link">
                  {t("menu.intro")}
                </Link>
                <div className="sub-menu last_menu" style={{ display: "none" }}>
                  <ul className="nav_sub_icon04" style={{ display: "none" }}>
                    <li>
                      <Link
                        to="/intro/about"
                        className="v_menu1_1 v_menu1_1_link"
                      >
                        {t("menu.about")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/intro/terms"
                        className="v_menu1_2 v_menu1_2_link"
                      >
                        {t("menu.terms")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/intro/notices"
                        className="v_menu1_3 v_menu1_3_link"
                      >
                        {t("menu.notices")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="menu">
                <Link
                  to="/observatory"
                  className="nav_menu_a v_menu2 v_menu2_link"
                >
                  {t("menu.observatory")}
                </Link>
                <div className="sub-menu" style={{ display: "none" }}>
                  <ul className="nav_sub_icon01" style={{ display: "none" }}>
                    <li>
                      <Link
                        to="/observatory/stations"
                        className="v_menu2_1 v_menu2_1_link"
                      >
                        {t("menu.stations")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/observatory/metadata"
                        className="v_menu2_2 v_menu2_2_link"
                      >
                        {t("menu.metadata")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="menu">
                <Link to="/data" className="nav_menu_a v_menu3 v_menu3_link">
                  {t("menu.data")}
                </Link>
                <div className="sub-menu">
                  <ul className="nav_sub_icon02">
                    <li>
                      <Link
                        to="/data/event-data"
                        className="v_menu3_1 v_menu3_1_link"
                      >
                        {t("menu.event-data")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/data/continuous-data"
                        className="v_menu3_2 v_menu3_2_link"
                      >
                        {t("menu.continuous-data")}
                      </Link>
                    </li>
                    {/* <li><Link to="/data/event-records" className="v_menu3_3 v_menu3_3_link">이벤트 상세검색</Link></li> */}
                    <li>
                      <Link
                        to="/data/web-services"
                        className="v_menu3_3 v_menu3_3_link"
                      >
                        {t("menu.web-services")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/data/kesmdb"
                        className="v_menu3_4 v_menu3_4_link"
                      >
                        {t("menu.kesmdb")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="menu">
                <Link
                  to="/analysis"
                  className="nav_menu_a v_menu5 v_menu5_link"
                >
                  {t("menu.analysis")}
                </Link>
                <div className="sub-menu" style={{ display: "none" }}>
                  <ul className="nav_sub_icon03" style={{ display: "none" }}>
                    <li>
                      <Link
                        to="/analysis/major-earthquakes"
                        className="v_menu5_1 v_menu5_1_link"
                      >
                        {t("menu.major-earthquakes")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/analysis/annual-report"
                        className="v_menu5_2 v_menu5_2_link"
                      >
                        {t("menu.annual-report")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/analysis/intensity-simulation"
                        className="v_menu5_3 v_menu5_3_link"
                      >
                        {t("menu.intensity-simulation")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/analysis/interactive-map"
                        className="v_menu5_4 v_menu5_4_link"
                      >
                        {t("menu.interactive-map")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/analysis/seismic-design-category-map"
                        className="v_menu5_5 v_menu5_5_link"
                      >
                        {t("menu.seismic-design-category-map")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/analysis/waveform-approximation"
                        className="v_menu5_6 v_menu5_6_link"
                      >
                        {t("menu.waveform-approximation")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="menu">
                <div style={{ height: 80 }}>
                  <button
                    type="button"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: 80,
                      height: 40,
                      margin: "-20px -40px",
                      borderRadius: 8,
                      background: "transparent",
                      cursor: "pointer",
                      color: logoColor,
                      border: `1px solid ${logoColor}`,
                      fontSize: 16,
                    }}
                    // eslint-disable-next-line no-restricted-globals
                    onClick={() =>
                      isLoggedIn
                        ? window.open(LOGOUT_URL, "_self")
                        : window.open(
                            `${LOGIN_URL}?redirect=${currentUrl}`,
                            "_self"
                          )
                    }
                  >
                    {isLoggedIn ? t("menu.logout") : t("menu.login")}
                  </button>
                </div>
                <div className="sub-menu userarea" style={{ display: "none" }}>
                  <ul className="nav_sub_icon03" style={{ display: "none" }}>
                    {isLoggedIn && (
                      <li>
                        <a href={MYPAGE_URL}>
                          <span className="text-cmain">
                            <strong>{userName}</strong>
                          </span>
                          님
                        </a>
                      </li>
                    )}
                    {isLoggedIn && (
                      <li>
                        <a href={MYPAGE_URL}>
                          <span className="button-sm primary-main indigo">
                            {t("menu.changeUserInfo")}
                          </span>
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </li>
              <li className="menu" style={{ width: 90 }}>
                {/* {(i18n?.language && !i18n.language.startsWith('en')) && (
                  <a className="nav_menu_a" style={{marginLeft: 10, fontSize: 15}} onClick={() => changeLanguage('en')}>ENG</a>
                )}
                {(i18n?.language && !i18n.language.startsWith('ko')) && (
                  <a className="nav_menu_a" style={{marginLeft: 10, fontSize: 15}} onClick={() => changeLanguage('ko')}>KOR</a>
                )} */}
                <div style={{ height: 80 }}>
                  {i18n?.language && (
                    <button
                      type="button"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: 80,
                        height: 40,
                        margin: "-20px -40px",
                        borderRadius: 8,
                        background: "transparent",
                        cursor: "pointer",
                        color: logoColor,
                        border: 0,
                        fontSize: 16,
                      }}
                      // eslint-disable-next-line no-restricted-globals
                      onClick={() =>
                        i18n.language.startsWith("en")
                          ? i18n.changeLanguage("ko")
                          : i18n.changeLanguage("en")
                      }
                    >
                      {i18n.language.startsWith("en") ? "한국어" : "English"}
                    </button>
                  )}
                </div>
              </li>
            </ul>
            {/* <div className="hide-on-med-and-down" style={{position: 'absolute', height: '100%', right: 0}}>
              <span
                style={{position: 'absolute', lineHeight: '85px', cursor: 'pointer'}}
              >
                ENG
              </span>
            </div> */}
          </div>
          <div className="selector_bg" style={{ display: "none" }}>
            <div className="bg_wrap"></div>
          </div>
          <div className="selector_back_bg" style={{ display: "none" }}>
            nav bg
          </div>
        </nav>

        <div className="mnav_container">
          <a className="btn-all-menu">
            <span className={menuIconClass}></span>
            <span className="sr-only">전체메뉴</span>
          </a>
          <div className="mnav_container_inner">
            <div className="web-top">
              <strong className="title">전체메뉴</strong>
            </div>
            <div className="box">
              <ul id="head_menu_all" className="depth1">
                <li className="lnb1 hassub active">
                  <Link to="/intro">
                    <span>{t("menu.intro")}</span>
                  </Link>
                  <ul className="depth2 sub01">
                    <li className="sub01">
                      <Link
                        to="/intro/about"
                        className="v_menu1_1 v_menu1_1_link"
                      >
                        {t("menu.about")}
                      </Link>
                    </li>
                    <li className="sub02">
                      <Link
                        to="/intro/terms"
                        className="v_menu1_2 v_menu1_2_link"
                      >
                        {t("menu.terms")}
                      </Link>
                    </li>
                    <li className="sub03">
                      <Link
                        to="/intro/notices"
                        className="v_menu1_3 v_menu1_3_link"
                      >
                        {t("menu.notices")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="lnb2 hassub">
                  <Link to="/observatory">{t("menu.observatory")}</Link>
                  <ul className="depth2 sub02">
                    <li className="sub01">
                      <Link
                        to="/observatory/stations"
                        className="v_menu2_1 v_menu2_1_link"
                      >
                        {t("menu.stations")}
                      </Link>
                    </li>
                    <li className="sub02">
                      <Link
                        to="/observatory/metadata"
                        className="v_menu2_2 v_menu2_2_link"
                      >
                        {t("menu.metadata")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="lnb3 hassub">
                  <Link to="/data">{t("menu.data")}</Link>
                  <ul className="depth2 sub03">
                    <li className="sub01">
                      <Link
                        to="/data/event-data"
                        className="v_menu3_1 v_menu3_1_link"
                      >
                        {t("menu.event-data")}
                      </Link>
                    </li>
                    <li className="sub02">
                      <Link
                        to="/data/continuous-data"
                        className="v_menu3_2 v_menu3_2_link"
                      >
                        {t("menu.continuous-data")}
                      </Link>
                    </li>
                    {/* <li className="sub03"><Link to="/data/event-records" className="v_menu3_3 v_menu3_3_link">이벤트 상세검색</Link></li> */}
                    <li className="sub03">
                      <Link
                        to="/data/web-services"
                        className="v_menu3_3 v_menu3_3_link"
                      >
                        {t("menu.web-services")}
                      </Link>
                    </li>
                    <li className="sub04">
                      <Link
                        to="/data/kesmdb"
                        className="v_menu3_4 v_menu3_4_link"
                      >
                        {t("menu.kesmdb")}
                      </Link>
                    </li>
                  </ul>
                </li>
                {/* <li className="lnb4 hassub">
                  <Link to="/openapi">OpenAPI</Link>
                  <ul className="depth2 sub04">
                    <li className="sub01"><Link to="/openapi/fdsnws" className="v_menu4_1 v_menu4_1_link">FDSNWS</Link></li>
                  </ul>
                </li> */}
                <li className="lnb5 hassub">
                  <Link to="/analysis">{t("menu.analysis")}</Link>
                  <ul className="depth2 sub05">
                    <li className="sub01">
                      <Link
                        to="/analysis/major-earthquakes"
                        className="v_menu5_1 v_menu5_1_link"
                      >
                        {t("menu.major-earthquakes")}
                      </Link>
                    </li>
                    <li className="sub02">
                      <Link
                        to="/analysis/annual-report"
                        className="v_menu5_2 v_menu5_2_link"
                      >
                        {t("menu.annual-report")}
                      </Link>
                    </li>
                    <li className="sub03">
                      <Link
                        to="/analysis/intensity-simulation"
                        className="v_menu5_3 v_menu5_3_link"
                      >
                        {t("menu.intensity-simulation")}
                      </Link>
                    </li>
                    <li className="sub04">
                      <Link
                        to="/analysis/interactive-map"
                        className="v_menu5_4 v_menu5_4_link"
                      >
                        {t("menu.interactive-map")}
                      </Link>
                    </li>
                    <li className="sub04">
                      <Link
                        to="/analysis/seismic-design-category-map"
                        className="v_menu5_5 v_menu5_5_link"
                      >
                        {t("menu.seismic-design-category-map")}
                      </Link>
                    </li>
                    <li className="sub05">
                      <Link
                        to="/analysis/waveform-approximation"
                        className="v_menu5_6 v_menu5_6_link"
                      >
                        {t("menu.waveform-approximation")}
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <div className="mobile_member_container">
                <div className="mobile_member_container_inner">
                  {isLoggedIn && <div>{userName}님</div>}
                  {isLoggedIn && (
                    <div className="white-outlint-btn">
                      <a href={MYPAGE_URL}>{t("menu.changeUserInfo")}</a>
                    </div>
                  )}
                  {isLoggedIn ? (
                    <div className="white-outlint-btn">
                      {/* <a href={LOGOUT_URL} target="_blank" rel="noopener noreferrer">로그아웃</a> */}
                      {/* <a onClick={e => dispatch(logout())}>로그아웃</a> */}
                      <a href={LOGOUT_URL}>{t("menu.logout")}</a>
                    </div>
                  ) : (
                    <div className="white-outlint-btn">
                      {/* <a href={LOGIN_URL} target="_blank" rel="noopener noreferrer">로그인</a> */}
                      {/* <a rel="noopener noreferrer" onClick={() => window.open(LOGIN_URL, '_blank').focus()}>로그인</a> */}
                      {/* <a rel="noopener noreferrer" onClick={() => window.open(`${LOGIN_URL}?redirect=${currentUrl}`, "_self")}>로그인</a> */}
                      <a
                        rel="noopener noreferrer"
                        href={`${LOGIN_URL}?redirect=${currentUrl}`}
                      >
                        {t("menu.login")}
                      </a>
                    </div>
                  )}
                  <hr />
                  <div className="white-outlint-btn">
                    {i18n?.language && !i18n.language.startsWith("en") && (
                      <a
                        role="button"
                        style={{ cursor: "pointer" }}
                        onClick={() => changeLanguage("en")}
                      >
                        English
                      </a>
                    )}
                    {i18n?.language && !i18n.language.startsWith("ko") && (
                      <a
                        role="button"
                        style={{ cursor: "pointer" }}
                        onClick={() => changeLanguage("ko")}
                      >
                        한국어
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <a className="btn-close">
              <span className="icon"></span>
              <span className="sr-only">전체메뉴 닫기</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
